import AuthenticatorService from "../../services/authenticator-service"
import { makeAuthenticatorResource } from "../resources/authenticator-resource-factory"

export const makeAuthenticatorService = (): AuthenticatorService => {
    return new AuthenticatorService(makeAuthenticatorResource())
}
